import React from "react";
import SiteShell from "../components/site/SiteShell";
import { Container, SectionHead, Button } from "../components/site/ui";
import { Reveal } from "../components/site/Reveal";
import { FinalCTA } from "./HomeNew";
import { SERVICES } from "../data/site";

export default function ServicesPage() {
  return (
    <SiteShell title="Services — GoBuildWeb" description="Business websites, e-commerce, redesigns, SEO, hosting, booking, custom web applications and growth tools — built by GoBuildWeb.">
      <section className="pt-[72px]">
        <Container className="py-16 text-center md:py-24">
          <Reveal>
            <SectionHead center eyebrow="What we do" title="Everything your business needs online" sub="From a first website to a full digital system — we build it, launch it, and help it grow." />
            <div className="mt-8 flex justify-center"><Button to="/get-started" size="lg" data-testid="services-get-website">Get My Website</Button></div>
          </Reveal>
        </Container>
      </section>

      <section className="pb-16 md:pb-24">
        <Container>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (
              <Reveal key={s.id} delay={(i % 3) * 0.06}>
                <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-colors hover:border-gold-500/40" data-testid={`service-${s.id}`}>
                  <span className="grid h-12 w-12 place-items-center rounded-xl bg-gold-500/10 text-gold-400"><s.icon size={22} /></span>
                  <h3 className="mt-5 font-display text-xl font-bold text-white">{s.title}</h3>
                  <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-gold-500">For {s.who}</p>
                  <p className="mt-3 flex-1 text-sm text-zinc-400">{s.desc}</p>
                  <Button to="/get-started" variant="ghost" className="mt-5 self-start px-0">Get started</Button>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
      <FinalCTA />
    </SiteShell>
  );
}
